<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Benefícios</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load mode="table"
              v-if="loadingBeneficios"/>
        <div class="col-md-12"
             v-else>

          <b-table
              :fields="[
                       {
                          key: 'protocolo',
                          label: $t('Detalhes'),
                        },
                      {
                        key: 'cadastrado',
                        label: $t('Cadastrado'),
                      },
                      {
                        key: 'status_nome',
                        label: $t('Status'),
                      },
          ]"
              :items="BeneficiosList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              <strong>{{ data.item.usuario.nome_completo }}</strong
              ><br/>
              Protocolo: <b>{{ data.item.protocolo }}</b>
              <br/>
              Nome do beneficio:
              <b>{{ data.item.beneficio.nome }}</b
              ><br/>
              Tipo:
              <b>{{ data.item.beneficio.tipo ? data.item.beneficio.tipo.descricao : "" }}</b
              >
            </template>
            <template v-slot:cell(cadastrado)="data">
              {{ data.item.cadastrado }}
            </template>
            <template v-slot:cell(status_nome)="data">
              <small class="text-muted text-xs">Status da Concessão: </small>
              <span class="small"
                    v-html="data.item.status_nome"></span>
              <br/>
              <small class="text-muted text-xs">Status do Parecer:</small>
              <span
                  class="small text-muted"
                  v-if="
									data.item.status_nome == 'AGUARDANDO VISITA TÉCNICA' ||
									data.item.status_parecer == 4
								"
              >VISITA TÉCNICA REALIZADA</span
              >
              <span v-else
                    v-html="data.item.status_parecer_nome"></span>
              <small class="text-muted"
                     v-if="data.item.atualizado"
              ><br/>{{ data.item.atualizado }}</small
              >
            </template>


            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Beneficios",
  props: ['familia'],
  data() {
    return {
      BeneficiosList: [],
      loadingBeneficios: true,
    }
  },
  mounted() {
    this.getBeneficios();
  },
  methods: {
    getBeneficios() {

      this.loadingBeneficios = true;
      axios
          .get(`api/dashboard/print/usuarios/beneficios/${this.familia}`)
          .then((response) => {
            this.BeneficiosList = response.data.data;
            this.loadingBeneficios = false;
          })
          .catch(() => {
            this.loadingBeneficios = false;
          });
    },

  },
}
</script>

<style scoped>

</style>